module.exports = __webpack_public_path__ + "07ab634261afb8db662539f295e710df.png";